import { h } from 'preact';
import Card from '../Card';

export default function Content({ data }) {
  return (
    <ul className="programming2020Container__main__body__content">
      {
        data.map((item) => (
          <Card item={item} />
        ))
      }
    </ul>
  );
}
